/* import __COLOCATED_TEMPLATE__ from './delete-mcp-server-modal.hbs'; */
/* RESPONSIBLE TEAM: team-data-foundations */
import Component from '@glimmer/component';

interface Args {
  onModalClose: () => void;
  onConfirmClick: () => void;
}

export default class DeleteMcpServerModal extends Component<Args> {
  constructor(owner: unknown, args: Args) {
    super(owner, args);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'WorkflowConnector::DeleteMcpServerModal': typeof DeleteMcpServerModal;
    'workflow-connector/delete-mcp-server-modal': typeof DeleteMcpServerModal;
  }
}
